const GET_USER = "USER_LOGIN";
const FETCH_GAMES = "FETCH_GAMES";
const FETCH_LANDING_PAGE_DATA = "FETCH_LANDING_PAGE_DATA";

export { GET_USER, FETCH_GAMES, FETCH_LANDING_PAGE_DATA };
